import { t } from '../i18n';

interface LegalPageProps {
  page: 'privacy' | 'terms';
}

/**
 * The privacy statement and the terms. Both are plain text on purpose: they
 * are read by people and by lawyers, not by a template engine.
 */
export function LegalPage({ page }: LegalPageProps): React.ReactElement {
  if (page === 'terms') {
    return (
      <article className="legal">
        <h1 className="legal__title">{t('legal.terms.title')}</h1>
        <p className="legal__lead">{t('legal.terms.lead')}</p>
        <h2>{t('legal.terms.use.title')}</h2>
        <p>{t('legal.terms.use.body')}</p>
        <h2>{t('legal.terms.content.title')}</h2>
        <p>{t('legal.terms.content.body')}</p>
        <h2>{t('legal.terms.liability.title')}</h2>
        <p>{t('legal.terms.liability.body')}</p>
        <h2>{t('legal.terms.contact.title')}</h2>
        <p>{t('legal.terms.contact.body')}</p>
      </article>
    );
  }

  return (
    <article className="legal">
      <h1 className="legal__title">{t('legal.privacy.title')}</h1>
      <p className="legal__lead">{t('legal.privacy.lead')}</p>

      <h2>{t('legal.privacy.who.title')}</h2>
      <p>{t('legal.privacy.who.body')}</p>

      <h2>{t('legal.privacy.data.title')}</h2>
      <ul>
        <li>{t('legal.privacy.data.account')}</li>
        <li>{t('legal.privacy.data.content')}</li>
        <li>{t('legal.privacy.data.files')}</li>
        <li>{t('legal.privacy.data.usage')}</li>
      </ul>

      <h2>{t('legal.privacy.processors.title')}</h2>
      <ul>
        <li>{t('legal.privacy.processors.hosting')}</li>
        <li>{t('legal.privacy.processors.mail')}</li>
        <li>{t('legal.privacy.processors.storage')}</li>
        <li>{t('legal.privacy.processors.login')}</li>
        <li>{t('legal.privacy.processors.dns')}</li>
      </ul>

      <h2>{t('legal.privacy.retention.title')}</h2>
      <ul>
        <li>{t('legal.privacy.retention.sessions')}</li>
        <li>{t('legal.privacy.retention.magicLinks')}</li>
        <li>{t('legal.privacy.retention.logs')}</li>
        <li>{t('legal.privacy.retention.backups')}</li>
        <li>{t('legal.privacy.retention.trash')}</li>
      </ul>

      <h2>{t('legal.privacy.rights.title')}</h2>
      <p>{t('legal.privacy.rights.body')}</p>

      <h2>{t('legal.privacy.contact.title')}</h2>
      <p>{t('legal.privacy.contact.body')}</p>
    </article>
  );
}
